import { render, staticRenderFns } from "./MapSvg.vue?vue&type=template&id=154478de&scoped=true&"
import script from "./MapSvg.vue?vue&type=script&lang=js&"
export * from "./MapSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154478de",
  null
  
)

export default component.exports